<span class="inline-spinner inline-spinner--{{ size }} inline-spinner--{{ color }}"></span>
